// function formatDateTime(datetime) {
//   const utcString = datetime.includes("Z")
//     ? datetime
//     : datetime.replace(" ", "T") + "Z";
//   const date = new Date(utcString);

//   return date.toLocaleString("en-US", {
//     year: "numeric",
//     month: "short",
//     day: "numeric",
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//   });
// }

function formatDateTime(datetime) {
  if (!datetime || typeof datetime !== "string") {
    return ""; // or return null / "Invalid date" depending on your use case
  }

  const utcString = datetime.includes("Z")
    ? datetime
    : datetime.replace(" ", "T") + "Z";

  const date = new Date(utcString);

  if (isNaN(date.getTime())) {
    return ""; // handle invalid date strings
  }

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export default formatDateTime;
